import {on, find, findAllIn, findIn, empty} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import asyncAppend from "@elements/async-append";
import fetch from '@elements/fetch';
import Collapse from 'bootstrap/js/dist/collapse';

export function init () {
    onFind('.js-ajax-accordion', function (element) {
        let accordionSelector = element.getAttribute('data-ajax-accordion-target');
        let accordion = find(accordionSelector);

        if (accordion) {
            let accordionInit = new Collapse(accordion);

            on('click', function () {
                let url = element.getAttribute('data-ajax-accordion-content-url');

                asyncAppend({
                    target: findAllIn('.js-ajax-accordion__content', accordion),
                    loading: findAllIn('.js-ajax-accordion__loading', accordion)
                }, fetch(url));
            }, element);


            on('hidden.bs.collapse', function () {
                empty(findIn('.js-ajax-accordion__content', accordion));
            }, accordion);
        } else {
            console.warn(`.js-ajax-accordion "${accordionSelector}" not found`)
        }
    });
}
